import React, { useEffect } from "react";
import styled from "styled-components";
import LeftSideBar from "./components/LeftSideBar";
import RightSection from "./components/RightSection";
import { ProfileSections } from "./components/types";
import { useNavigate, useSearchParams } from "react-router-dom";
import { WebPaths } from "../../../routes/data";
import Constaint from "../layout/components/Constaint";
import useIsLoggedIn from "../../../hooks/useIsLoggedIn";
import PopUp from "../components/PopUp";
import { useSnapshot } from "valtio";
import { userDataStore } from "../../../store/userData";
import useOpener from "../../../hooks/useOpener";
import { mediaObj } from "../../../styles/Media";
import StartingModal from "./components/business/billing/components/StartingModal";
import { isBusinessDataStore } from "../../../store/isBusinessData";
import { useGetBusinessProfile } from "../../../hooks/business/useAuth";

const PROFILE = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const getType = searchParams.get("active");
  const navigate = useNavigate();
  const isLoggedIn = useIsLoggedIn();
  const { open, onOpen, onClose } = useOpener();
  const { isBusinessData } = useSnapshot(isBusinessDataStore);
  const { data: businessUserData } = useGetBusinessProfile(isBusinessData);
  const { userData } = useSnapshot(userDataStore);

  useEffect(() => {
    if (!isLoggedIn) {
      navigate(WebPaths.Auth);
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    if (isLoggedIn && !getType) {
      searchParams.set("active", ProfileSections.dashboard);
      setSearchParams(searchParams);
    }
  }, [searchParams, getType, setSearchParams, isLoggedIn]);

  return (
    <>
      <Constaint>
        <Wrapper>
          <PopUp isFormCompleted={userData?.currentFormInfo.isFormCompleted!} />
          {businessUserData &&
            !businessUserData?.paymentInfo?.subscriptionType && (
              <StartingModal />
            )}
          <Container>
            <LeftSideBar open={open} onClose={onClose} onOpen={onOpen} />
            <RightSection />
          </Container>
        </Wrapper>
      </Constaint>
    </>
  );
};

export default PROFILE;

const Wrapper = styled.div`
  margin: 28px 0;
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: 267px minmax(0, 1fr);
  gap: 48px;
  margin-bottom: 170px;

  ${mediaObj.smallDesktop} {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;
